import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({

  line: {
    display: 'flex',
    gap: 12,
    flexWrap: 'wrap',
    justifyContent: 'space-between',

    [theme.breakpoints.down('680')]: {
      '&': {
        flexWrap: 'nowrap',
        flexDirection: 'column',
        gap: 0,
      },
      '& .MuiFormControl-root': {
        maxWidth: '100%',
        width: '100%!important',
      },
    },
  },
  accordion: {
    marginTop: '12px',
    width: '100% !important',
  },
  form: {
    width: '100%',
  },
  heading: {
    marginLeft: '12px !important',
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  name: {
    maxWidth: 180
  },
  title: {
    marginTop: 0,
    marginBottom: 4
  }

  

}))
